import React from 'react';
import { Alert } from '@mui/material';
import { useAppUi } from '../app/useAppUi';

export function ErrorBanner({ error }) {
  const { t } = useAppUi();
  if (!error) return null;
  const msg =
    error?.response?.data?.message ||
    error?.message ||
    t('errors.generic');
  return (
    <Alert severity="error" sx={{ mb: 2 }}>
      {msg}
    </Alert>
  );
}

